/**
 * GA4 event emission for the web bundles
 */

// blocks/ga.twig declares gtag inline. A layout without that block has no gtag,
// and the event is dropped rather than thrown.
export function trackEvent(name, params = {}) {
    if (typeof gtag === 'undefined') {
        return;
    }

    gtag('event', name, params);
}
